import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
interface LegalModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function LegalModal({
  open,
  onClose,
  title,
  children
}: LegalModalProps) {
  useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);
  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (open) window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [open, onClose]);
  return <AnimatePresence data-id="element-107">
      {open && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2
    }} className="fixed inset-0 z-50 bg-black/70 backdrop-blur-sm flex items-end sm:items-center justify-center p-0 sm:p-4" onClick={onClose} role="dialog" aria-modal="true" aria-labelledby="legal-modal-title" data-id="element-108">
          <motion.div initial={{
        y: 40,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} exit={{
        y: 40,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeOut'
      }} className="bg-[#FAF5EE] w-full sm:max-w-2xl max-h-[90vh] sm:max-h-[85vh] flex flex-col sm:rounded-sm shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-109">
            <div className="flex items-center justify-between px-5 sm:px-8 py-4 border-b border-[#E0D5C1] flex-shrink-0" data-id="element-110">
              <h2 id="legal-modal-title" className="font-serif text-xl sm:text-2xl text-[#5C1A2B]" data-id="element-111">
                {title}
              </h2>
              <button onClick={onClose} aria-label="Cerrar" className="p-2 -mr-2 text-[#5C1A2B] hover:text-[#C86B5E] transition-colors" data-id="element-112">
                <XIcon className="w-5 h-5" data-id="element-113" />
              </button>
            </div>
            <div className="overflow-y-auto px-5 sm:px-8 py-6 text-sm text-[#4A4A4A] font-light leading-relaxed space-y-4" data-id="element-114">
              {children}
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}